var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.025 363.024",
    style: {
      enableBackground: "new 0 0 363.025 363.024"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.512 363.024C81.43 363.024 0 281.601 0 181.513 0 81.424 81.43 0 181.512 0c100.083 0 181.513 81.424 181.513 181.513 0 100.088-81.43 181.511-181.513 181.511zm0-351.314C87.88 11.71 11.71 87.886 11.71 181.513s76.17 169.802 169.802 169.802c93.633 0 169.803-76.175 169.803-169.802S275.145 11.71 181.512 11.71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m147.957 258.935-64.889-64.889 8.28-8.279 56.609 56.608 123.214-123.209 8.28 8.279z"
  })));
};
export default SvgTickCircle;